"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EightCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var EightCircleFilled = function EightCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F4F9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.335 29.552c-1.8.552-2.855 1.968-2.855 3.936 0 2.832 2.207 4.776 5.471 4.776 3.36 0 5.569-1.968 5.569-4.92 0-1.392-.529-2.496-1.537-3.192-.36-.24-.695-.384-1.343-.6 1.44-.6 2.231-1.776 2.231-3.36 0-2.4-1.992-4.104-4.824-4.104-2.904 0-4.944 1.704-4.944 4.176 0 1.56.84 2.784 2.232 3.288zm2.712-5.424c1.465 0 2.424.888 2.424 2.28 0 1.416-.96 2.304-2.471 2.304-1.488 0-2.497-.936-2.497-2.304 0-1.392.985-2.28 2.544-2.28zm-.024 6.408c1.753 0 2.905 1.152 2.905 2.88 0 1.776-1.056 2.808-2.856 2.808-1.848 0-3-1.104-3-2.88 0-1.704 1.175-2.808 2.951-2.808z",
    fill: "#97BA1E"
  }));
};

exports.EightCircleFilled = EightCircleFilled;
var _default = EightCircleFilled;
exports.default = _default;